import {
  IonButton,
  IonButtons,
  IonIcon,
  IonItem,
  IonList,
  IonPopover,
  useIonRouter,
} from "@ionic/react";
import { ellipsisHorizontal, ellipsisVertical } from "ionicons/icons";

export const ReselectAllFavouriteButton = () => {
  const navigation = useIonRouter();
  return (
    <>
      <IonButtons slot="primary">
        <IonButton id="my-favourite-popover">
          <IonIcon
            slot="icon-only"
            ios={ellipsisHorizontal}
            md={ellipsisVertical}
          ></IonIcon>
        </IonButton>
      </IonButtons>

      <IonPopover trigger="my-favourite-popover">
        <IonList>
          <IonItem
            button
            lines="none"
            onClick={() => {
              navigation.push(`/profiling/go-to`, "forward");
            }}
          >
            Reselect all favourites
          </IonItem>
        </IonList>
      </IonPopover>
    </>
  );
};
